/**
 * 분석 화면 표시용 포맷 유틸 (순수 함수).
 */

export type Granularity = 'hour' | 'day'

export const DAY_LABELS = ['일', '월', '화', '수', '목', '금', '토'] as const

// 클릭이 1이라도 있으면 눈에 보이도록 보장하는 최소 히트맵 강도
const MIN_VISIBLE_INTENSITY = 0.08

const DAY_BUCKET = /^(\d{4})-(\d{2})-(\d{2})$/
const HOUR_BUCKET = /^(\d{4})-(\d{2})-(\d{2})T(\d{2})$/

/** 버킷 키를 사람이 읽는 축 라벨로 변환 */
export function formatBucketLabel(
  bucket: string,
  granularity: Granularity
): string {
  if (granularity === 'hour') {
    const match = HOUR_BUCKET.exec(bucket)
    return match ? `${Number(match[4])}시` : bucket
  }

  const match = DAY_BUCKET.exec(bucket)
  return match ? `${Number(match[2])}월 ${Number(match[3])}일` : bucket
}

/** 큰 수를 K/M 단위로 축약 */
export function formatCompactNumber(value: number): string {
  const sign = value < 0 ? '-' : ''
  const abs = Math.abs(value)

  if (abs >= 1_000_000) {
    return `${sign}${trimZero(abs / 1_000_000)}M`
  }
  if (abs >= 1_000) {
    return `${sign}${trimZero(abs / 1_000)}K`
  }
  return `${sign}${abs}`
}

function trimZero(value: number): string {
  return value.toFixed(1).replace(/\.0$/, '')
}

/** 히트맵 셀 색 강도(0~1) */
export function heatmapIntensity(clicks: number, max: number): number {
  if (max <= 0 || clicks <= 0) {
    return 0
  }
  return Math.max(MIN_VISIBLE_INTENSITY, clicks / max)
}

/** 증감률 표시 문자열 */
export function formatChange(value: number): string {
  if (value === 0) {
    return '0%'
  }
  const sign = value > 0 ? '+' : ''
  return `${sign}${value}%`
}

/** 긴 URL 을 가운데 생략해 양 끝을 보존 */
export function truncateMiddle(value: string, maxLength: number): string {
  if (value.length <= maxLength) {
    return value
  }
  const keep = maxLength - 1
  const head = Math.ceil(keep / 2)
  const tail = Math.floor(keep / 2)
  return `${value.slice(0, head)}…${value.slice(value.length - tail)}`
}
